import {message} from "antd"
import {label} from "./label.service"
import {BehaviorSubject} from "rxjs"
import {authenticationService} from "services/authentication.service"

const errorCode = new BehaviorSubject(null)

const handleError = (error) => {
	if (error.response) {
		errorCode.next(error.response.status)
		if (error.response.status === 401){
			authenticationService.logout()
			message.error(label.get("token.expired"), 10)
		} else if (error.response.status === 404) {
			message.error(label.get("connection.error"))
		}

		console.log(error.response.data)
		console.log(error.response.status)
		console.log(error.response.headers)
	} else if (error.request) {
		console.log(error.request)
	} else {
		console.log("Error", error.message)
	}
	console.log(error.config)
}


const handleLoginError = (error) => {
	if (error.response.status === 401) {
		message.error(label.get("login.error"), 10)
	} else {
		handleError(error)
	}
}

export const errorService = {
	handleError,
	handleLoginError,
	error: errorCode.asObservable()
}